<template>
  <a-layout>
    <a-layout-header>
      <layout-header v-model="activeSelect" @publish="publishProcess" @preview="preview" @reLoadData="reLoadData" :value="activeSelect"></layout-header>
    </a-layout-header>
    <a-layout-content class="layout-body">
      <form-base-setting ref="baseSetting" v-show="activeSelect === 'baseSetting'" :formData="formData"/>
<!--      <form-design ref="formSetting" v-show="activeSelect === 'formSetting'"/>-->
      <process-design ref="processDesign" v-show="activeSelect === 'processDesign'"/>
<!--      <form-pro-setting ref="proSetting" v-show="activeSelect === 'proSetting'"/>-->
    </a-layout-content>
    <w-dialog :showFooter="showFooter" v-model="validVisible" title="设置项检查" @cancel="validVisible=false">
      <a-steps align-center :current="validStep" finish-status="success">
        <a-step
          v-for="(step, i) in validOptions"
          :title="step.title"
          :key="i"
          :icon="step.icon"
          :status="step.status"
          :description="step.description">
          <a-icon slot="icon" :type="step.icon" />
        </a-step>
      </a-steps>
      <a-result :status="validIcon" :title="errTitle" :subTitle="validResult.desc">
        <i slot="icon" style="font-size: 30px" v-if="!validResult.finished" class="el-icon-loading"></i>
        <div slot="subTitle" class="err-info" v-if="validResult.errs.length > 0">
          <e-ellipsis hover-tip v-for="(err, i) in validResult.errs" :key="i + '_err'" :content="err">
            <i slot="pre" class="el-icon-warning-outline"></i>
          </e-ellipsis>
        </div>
        <template #extra>
          <a-button type="primary" v-if="validResult.finished" @click="doAfter">
            {{ validResult.action }}
          </a-button>
        </template>
      </a-result>
    </w-dialog>
  </a-layout>

</template>

<script>
import LayoutHeader from './LayoutHeader'
import { WDialog, EEllipsis } from '@/components'
import { getFormDetail, createForm, updateFormDetail } from '@/api/oa_approve'
import FormBaseSetting from '@/views/a-oa/approve/admin/layout/FormBaseSetting'
import FormDesign from '@/views/a-oa/approve/admin/layout/FormDesign'
import ProcessDesign from '@/views/a-oa/approve/admin/layout/ProcessDesign'
import FormProSetting from '@/views/a-oa/approve/admin/layout/FormProSetting'
import { mapMutations } from 'vuex'

export default {
  name: 'FormProcessDesign',
  components: { LayoutHeader, FormBaseSetting, FormDesign, ProcessDesign, FormProSetting, WDialog, EEllipsis },
  data () {
    return {
      isNew: true,
      formData: undefined,
      validStep: 0,
      timer: null,
      activeSelect: 'baseSetting',
      showFooter: false,
      validVisible: false,
      validResult: {},
      validOptions: [
        // status : wait process finish error
        { title: '基础信息', description: '', icon: '', status: '' },
        // { title: '审批表单', description: '', icon: '', status: '' },
        { title: '审批流程', description: '', icon: '', status: '' }
        // { title: '扩展设置', description: '', icon: '', status: '' }
      ],
      // validComponents: ['baseSetting', 'formSetting', 'processDesign', 'proSetting'],
      validComponents: ['baseSetting', 'processDesign'],
      categories: this.$Dictionaries.approval_category
    }
  },
  computed: {
    setup () {
      return this.$store.state.oaApprove.design
    },
    errTitle () {
      if (this.validResult.finished && !this.validResult.success) {
        return this.validResult.title + ` (${this.validResult.errs.length}项错误) 😥`
      }
      return this.validResult.title
    },
    validIcon () {
      // 'success' | 'error' | 'info' | 'warning'| '404' | '403' | '500'
      if (!this.validResult.finished) {
        return 'info'
      } else if (this.validResult.success) {
        return 'success'
      } else {
        return 'warning'
      }
    }
  },
  created () {
    this.showValiding()
    const formId = this.$route.query.code
    // 判断传参，决定是新建还是加载原始数据
    this.loadInitFrom()
    if (this.$isNotEmpty(formId)) {
      this.isNew = false
      this.loadFormInfo(formId)
    }
    let group = this.$route.query.groupId
    if (group === undefined || isNaN(group)) {
      group = undefined
    }
    this.setup.groupId = this.$isNotEmpty(group) ? parseInt(group) : undefined
  },
  beforeDestroy () {
    this.stopTimer()
  },
  methods: {
    ...mapMutations('oaApprove', ['loadForm', 'setDiagramMode']),
    loadFormInfo (formId) {
      getFormDetail(formId).then(rsp => {
        console.log('getFormDetail', rsp)
        if (rsp.data.entries.length > 0) {
          const formInfo = rsp.data.entries[0]
          this.setFormData(formInfo)
        }
      }).catch(err => {
        this.$message.error(err)
      })
    },
    setFormData (formInfo) {
      formInfo.formId = formInfo.id
      formInfo.formName = formInfo.template_name
      formInfo.groupId = formInfo.group_id
      formInfo.group_id = this.$route.query.groupId ? this.$route.query.groupId : undefined
      formInfo.settings = JSON.parse(formInfo.settings)
      formInfo.formItems = JSON.parse(formInfo.form_items)
      formInfo.process = JSON.parse(formInfo.process)
      this.formData = formInfo
      this.loadForm(formInfo)
      // this.$store.commit('loadForm', formInfo)
      for (const component of this.validComponents) {
        this.$refs[component].reLoadData()
      }
    },
    getCategoryName (category) {
      let isOk = false
      let c = category
      for (let i = 0; i < this.categories.length; i++) {
        const children = this.categories[i].children
        if (isOk) {
          break
        }
        if (children !== undefined && children.length > 0) {
          for (let j = 0; j < children.length; j++) {
            const child = children[j]
            if (child['key'] === category) {
              c = child.label
              isOk = true
              break
            }
          }
        }
      }
      return c
    },
    loadInitFrom () {
      const initForm = {
        formId: null,
        formName: undefined,
        logo: {
          icon: 'el-icon-eleme',
          background: '#1e90ff'
        },
        settings: {
          commiter: [],
          admin: [],
          sign: false,
          notify: {
            types: ['APP'],
            title: '通知标题'
          }
        },
        groupId: this.$route.query.groupId ? this.$route.query.groupId : undefined,
        category: undefined,
        formItems: [],
        process: {
          id: 'root',
          parentId: null,
          type: 'ROOT',
          name: '发起人',
          desc: '任何人',
          props: {
            assignedUser: [],
            formPerms: []
          },
          children: {}
        },
        remark: ''
      }
      this.formData = initForm
      this.loadForm(initForm)
      this.setDiagramMode('design')
    },
    validateDesign () {
      this.validVisible = true
      this.validStep = 0
      this.showValiding()
      this.stopTimer()
      this.timer = setInterval(() => {
        const errors = this.$refs[this.validComponents[this.validStep]].validate()
        this.validResult.errs = errors
        if (Array.isArray(this.validResult.errs) && this.validResult.errs.length === 0) {
          this.validOptions[this.validStep].status = 'finish'
          this.validStep++
          if (this.validStep >= this.validOptions.length) {
            this.stopTimer()
            this.showValidFinish(true)
          }
        } else {
          this.stopTimer()
          this.validOptions[this.validStep].status = 'error'
          this.showValidFinish(false, this.getDefaultValidErr())
        }
      }, 1000)
    },
    getDefaultValidErr () {
      switch (this.validStep) {
        case 0:
          return '请检查基础设置项'
        case 1:
          return '请检查审批表单相关设置'
        case 2:
          return '请检查审批流程，查看对应标注节点错误信息'
        case 3:
          return '请检查扩展设置'
        default:
          return '未知错误'
      }
    },
    showValidFinish (success, err) {
      this.validResult.success = success
      this.validResult.finished = true
      this.validResult.title = success ? '校验完成 😀' : '校验失败 '
      this.validResult.desc = success ? '流程设置项校验成功，是否提交？' : err
      this.validResult.action = success ? '提 交' : '去修改'
    },
    showValiding () {
      this.validResult = {
        errs: [],
        finished: false,
        success: false,
        title: '检查中...',
        action: '处理',
        desc: '正在检查流程设置项'
      }
      this.validStep = 0
      this.validOptions.forEach(op => {
        op.status = ''
        op.icon = ''
        op.description = ''
      })
    },
    doAfter () {
      if (this.validResult.success) {
        this.doPublish()
      } else {
        this.activeSelect = this.validComponents[this.validStep]
        this.validVisible = false
      }
    },
    stopTimer () {
      if (this.timer) {
        clearInterval(this.timer)
      }
    },
    preview () {
      this.validateDesign()
    },
    publishProcess () {
      this.validateDesign()
    },
    reLoadData (info) {
      this.setFormData(info)
    },
    doPublish () {
      this.$confirm('确认发布后流程立即生效，是否继续?', '提示', {
        confirmButtonText: '发布',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        console.log(this.setup)
        const processNew = JSON.parse(JSON.stringify(this.setup.process))
        const formItemsNew = JSON.parse(JSON.stringify(this.setup.formItems))
        const template = {
          template_name: this.setup.formName,
          category: this.setup.category,
          settings: JSON.stringify(this.setup.settings),
          group_id: this.setup.groupId,
          form_items: JSON.stringify(formItemsNew),
          process: JSON.stringify(processNew),
          remark: this.setup.remark
        }
        let isOk = false
        for (let i = 0; i < this.categories.length; i++) {
          const children = this.categories[i].children
          if (isOk) {
            break
          }
          if (children !== undefined && children.length > 0) {
            for (let j = 0; j < children.length; j++) {
              const child = children[j]
              if (child['label'] === template.category) {
                template.category = child.key
                isOk = true
                break
              }
            }
          }
        }
        if (this.isNew || !this.$isNotEmpty(this.setup.formId)) {
          createForm(template).then(rsp => {
            if (rsp.code === 1000) {
              this.$message.success('创建表单成功')
              this.$router.back()
            } else {
              this.$message.warning('创建失败：' + rsp.msg)
            }
          }).catch(err => {
            this.$message.error(err)
          })
        } else {
          updateFormDetail(template, this.setup.formId).then(rsp => {
            if (rsp.code === 1000) {
              this.$message.success('更新表单成功')
              this.$router.back()
            } else {
              this.$message.warning('创建失败：' + rsp.msg)
            }
          }).catch(err => {
            this.$message.error(err)
          })
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>

.layout-body {
  min-width: 980px;
}

/deep/ .el-step {
  .is-success {
    color: #2a99ff;
    border-color: #2a99ff;
  }
}

.err-info{
  max-height: 180px;
  overflow-y: auto;
  & > div{
    padding: 5px;
    margin: 2px 0;
    width: 220px;
    text-align: left;
    border-radius: 3px;
    background: rgb(242 242 242);
  }
  i{
    margin: 0 5px;
  }
}

::-webkit-scrollbar {
  width: 2px;
  height: 2px;
  background-color: white;
}

::-webkit-scrollbar-thumb {
  border-radius: 16px;
  background-color: #e8e8e8;
}

</style>
